import { render, staticRenderFns } from "./ComplianceChart.vue?vue&type=template&id=083b6352"
import script from "./ComplianceChart.vue?vue&type=script&lang=ts"
export * from "./ComplianceChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('083b6352')) {
      api.createRecord('083b6352', component.options)
    } else {
      api.reload('083b6352', component.options)
    }
    module.hot.accept("./ComplianceChart.vue?vue&type=template&id=083b6352", function () {
      api.rerender('083b6352', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cards/ComplianceChart.vue"
export default component.exports